<template>
  <section class="view">
    <router-view />
  </section>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.view {
  &--mask {
    position: fixed;
    z-index: 99;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    min-height: 100vh;
    background-color: rgba($black, 0.75);
  }

  &--opaque {
    opacity: 0.25;
  }
}

.overlay {
  position: fixed;
  z-index: 999;
  top: 40px;
  left: 0px;
  width: 100%;
  height: auto;

  @media screen and (min-width: $breakpointSm) {
    top: 100px;
    left: calc(50% - 225px);
    width: 450px;
  }

  @media screen and (min-width: $breakpointLg) {
    top: 108px;
  }
}

.transition {
  &--header {
    &-enter {
      transform: translateY(-100px);
      opacity: 0;
    }

    &-enter-active {
      transition: opacity 0.6s ease-in, transform 0.6s ease-out;
    }

    &-leave-active {
      transition: opacity 0.4s ease-out, transform 0.4s ease-out;
    }

    &-leave-to {
      transform: translateY(-100px);
      opacity: 0;
    }
  }

  &--toLeft {
    &-enter {
      transform: translateX(-25px);
      opacity: 0;
    }

    &-enter-active {
      transition: opacity 0.4s ease-out, transform 0.4s ease-out;
    }

    &-leave-active {
      transition: opacity 0.3s ease-in, transform 0.3s ease-in;
    }

    &-leave-to {
      transform: translateX(100px);
      opacity: 0;
    }
  }

  &--toRight {
    &-enter {
      transform: translateX(25px);
      opacity: 0;
    }

    &-enter-active {
      transition: opacity 0.4s ease-out, transform 0.4s ease-out;
    }

    &-leave-active {
      transition: opacity 0.3s ease-in, transform 0.3s ease-in;
    }

    &-leave-to {
      transform: translateX(-100px);
      opacity: 0;
    }
  }

  &--toUp {
    &-enter {
      transform: translateY(15px);
      opacity: 0;
    }

    &-enter-active {
      transition: opacity 0.4s ease-out, transform 0.4s ease-out;
    }

    &-leave-active {
      transition: opacity 0.3s ease-in, transform 0.3s ease-in;
    }

    &-leave-to {
      transform: translateY(-75px);
      opacity: 0;
    }
  }

  &--toDown {
    &-enter {
      transform: translateY(-15px);
      opacity: 0;
    }

    &-enter-active {
      transition: opacity 0.4s ease-out, transform 0.4s ease-out;
    }

    &-leave-active {
      transition: opacity 0.3s ease-in, transform 0.3s ease-in;
    }

    &-leave-to {
      transform: translateY(75px);
      opacity: 0;
    }
  }

  &--toAuth {
    &-enter {
      transform: translateY(-100px);
      opacity: 0;
    }

    &-enter-active {
      transition: opacity 0.4s ease-in, transform 0.3s ease-out;
    }

    &-leave-active {
      transition: opacity 0.4s ease-in, transform 0.4s ease-in;
    }

    &-leave-to {
      transform: translateY(-175px);
      opacity: 0;
    }
  }

  &--fromAuth {
    &-enter {
      transform: translateY(25px);
      opacity: 0;
    }

    &-enter-active {
      transition: opacity 0.4s ease-in, transform 0.3s ease-out;
    }

    &-leave-active {
      transition: opacity 0.4s ease-in, transform 0.4s ease-in;
    }

    &-leave-to {
      transform: translateY(-100px);
      opacity: 0;
    }
  }
}

</style>
